module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-score"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "not-required",
    class: _vm.required ? 'required' : ''
  }, [_vm._v("*")]), _vm._v(_vm._s(("评分项：" + _vm.title))), (_vm.tipCode) ? _c('common-tooltip', {
    staticClass: "tooltip",
    attrs: {
      "tipCode": _vm.tipCode
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.disabledDownload,
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.handleExport
    }
  }, [_vm._v("数据下载")]), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    staticClass: "upload",
    attrs: {
      "action": 'http://',
      "show-file-list": true,
      "accept": _vm.acceptType,
      "auto-upload": false,
      "on-change": _vm.valid,
      "on-remove": _vm.valid,
      "limit": 1
    },
    nativeOn: {
      "click": function($event) {
        return (function (e) { return _vm.disabledUpload ? e.preventDefault() : ''; })($event)
      }
    }
  }, [_c('el-button', {
    staticClass: "btn-upload",
    class: _vm.error ? 'error' : '',
    attrs: {
      "disabled": _vm.disabledUpload,
      "type": "primary",
      "plain": ""
    }
  }, [_vm._v("数据上传")])], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4d5edbb1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d5edbb1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CommonScore.vue
// module id = 1574
// module chunks = 7